import { Box, getVariant } from '@apia/theme';
import React from 'react';
import Calendar from 'react-calendar';

export interface ICalModal {
  handleClickDay: (date: Date) => void;
  calValue?: Date;
  locale: string;
}

const CalModal = React.forwardRef<HTMLDivElement, ICalModal>(
  ({ handleClickDay, calValue, locale }) => {
    return (
      <Box
        {...getVariant('layout.common.components.datePicker')}
        className="datePicker"
      >
        <Calendar
          onClickDay={handleClickDay}
          locale={locale}
          value={calValue || new Date()}
          nextLabel="›"
          next2Label="»"
          prevLabel="‹"
          prev2Label="«"
        />
      </Box>
    );
  },
);

export default CalModal;
